import { useEffect, useState } from 'react'

type Theme = 'light' | 'dark'

const QUERY = '(prefers-color-scheme: dark)'

const detect = (): Theme => {
  if (typeof window === 'undefined' || !window.matchMedia) return 'light'
  return window.matchMedia(QUERY).matches ? 'dark' : 'light'
}

/**
 * Reads `prefers-color-scheme` and reflects it on `<html data-theme>`.
 *
 * Slim's NXDThemeProvider depends on goldfish's `useAppearancePreferences`
 * (persisted preference + alert duration). For the standalone boilerplate
 * we follow system preference only; persistence can be added later without
 * touching consumers.
 */
export const useSystemTheme = (): Theme => {
  const [theme, setTheme] = useState<Theme>(detect)

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return
    const mql = window.matchMedia(QUERY)
    const onChange = () => setTheme(mql.matches ? 'dark' : 'light')
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  useEffect(() => {
    document.documentElement.dataset['theme'] = theme
  }, [theme])

  return theme
}
